import { Button } from "@/components/ui/button";
import { UserCheck, UserX } from "lucide-react";

interface StaffAccountStatusProps {
  staff: {
    id: string;
    user_id?: string;
    email: string;
    first_name: string;
    last_name: string;
  };
  size?: "sm" | "default" | "lg";
}

export const StaffAccountStatus = ({ staff, size = "sm" }: StaffAccountStatusProps) => {
  // Show different states based on staff account status
  if (staff.user_id) {
    // Staff member was created from existing user - has active account
    return (
      <Button 
        size={size} 
        variant="secondary" 
        disabled 
        className="w-full bg-green-50 text-green-700 border-green-200 hover:bg-green-50"
      >
        <UserCheck className="h-4 w-4 mr-2" />
        Account Active
      </Button>
    );
  }

  // Staff member doesn't have user account
  return (
    <Button 
      size={size} 
      variant="outline" 
      disabled 
      className="w-full bg-yellow-50 text-yellow-700 border-yellow-200 hover:bg-yellow-50"
    >
      <UserX className="h-4 w-4 mr-2" />
      No Account
    </Button>
  );
};